// test2237
(2237 && 0);
